<template>
  <v-container fluid fill-height class="custom--container">
    <v-row align-center justify="center">
      <v-col cols="8" offset="2">
        <v-carousel
          v-model="model"
          hide-delimiter-background
          :show-arrows="false"
          height="60vh"
          cycle
        >
          <v-carousel-item v-for="exp in exps.content" :key="exp.title">
            <v-sheet
              height="100%"
              tile
              color="rgba(244, 219, 232, 0.57)"
              class="d-flex flex-column"
            >
              <!-- SMALL DEVICES -->
              <!-- For small devices, have image on top of the description -->
              <template v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
                <!-- STANDARD LAYOUT -->
                <template v-if="!exp.embed">
                  <!-- image logo -->
                  <v-row
                    align="center"
                    justify="center"
                    class="d-flex flex-shrink-1"
                  >
                    <v-col cols="8">
                      <v-lazy>
                        <v-img
                          height="20vh"
                          aspect-ratio="1"
                          contain
                          v-bind:src="exp.img"
                          class="mx-auto mb-0 pb-0"
                        />
                      </v-lazy>
                    </v-col>
                  </v-row>
                  <v-row
                    align-content="center"
                    justify="center"
                    class="d-flex flex-grow-1"
                  >
                    <!-- description portion -->
                    <v-col cols="10">
                      <div class="ma-0 pa-3 exp--text-container">
                        <div class="exp-title mt-0 pt-0">
                          {{ exp.title }}
                        </div>
                        <div class="exp-subtitle">
                          {{ exp.subtitle }} • {{ exp.when }}
                        </div>

                        <div class="exp-desc">
                          {{ exp.description }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </template>

                <!-- EMBED POSTS -->
                <template v-else>
                  <v-row align="center" justify="center" class="flex-grow-1">
                    <v-col align-self="center" cols="10" class="fill-height">
                      <iframe
                        :src="exp.embed"
                        width="100%"
                        height="150%"
                        class="exp-iframe"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="flex-shrink-1">
                    <v-col align-self="end">
                      <div class="exp-title">
                        {{ exp.title }}
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </template>
              <!-- MEDIUM TO LARGE DEVICES -->
              <!-- For medium to large devices, place image next to content -->
              <template v-else>
                <v-row align="center" justify-content="end">
                  <!-- image logo -->
                  <v-col v-if="!exp.embed" cols="4" offset="1">
                    <v-lazy>
                      <v-img
                        height="25vh"
                        aspect-ratio="1"
                        contain
                        v-bind:src="exp.img"
                      />
                    </v-lazy>
                  </v-col>
                  <!-- embed frame -->
                  <v-col v-else offset="1" cols="4" class="fill-height">
                    <iframe
                      :src="exp.embed"
                      width="150%"
                      height="100%"
                      style="-webkit-transform:scale(0.75);-moz-transform-scale(0.75);scale(0.75);"
                    />
                  </v-col>
                  <!-- description portion -->
                  <v-col offset="1" align-self="center" cols="5">
                    <v-card
                      class="ma-1 pa-1"
                      flat
                      color="white"
                      v-if="!exp.embed"
                    >
                      <v-card-title class="justify-center text">
                        <p class="exp-title">{{ exp.title }}</p>
                      </v-card-title>
                      <v-card-subtitle class="exp-subtitle">
                        <p class="exp-subtitle">
                          {{ exp.subtitle }} • {{ exp.when }}
                        </p>
                      </v-card-subtitle>
                      <v-card-text class="exp-desc">
                        <p class="exp-desc">{{ exp.description }}</p>
                      </v-card-text>
                      <v-card-actions class="justify-center" v-if="exp.link">
                        <v-btn :href="exp.link" target="_blank">
                          <v-icon>
                            mdi-open-in-new
                          </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                    <div v-else class="exp-title">
                      {{ exp.title }}
                    </div>
                  </v-col>
                </v-row>
              </template>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <scroll-helper :scroll="exps.scroll" />
    </v-row>
  </v-container>
</template>

<script>
import ScrollHelper from "./ScrollHelper.vue";
export default {
  components: { ScrollHelper },
  name: "Carousel",
  props: ["exps"],
  data: () => ({
    model: null,
  }),
};
</script>
